import React, {forwardRef} from 'react';
import SearchIcon from "../../../assets/icons/SearchIcon";
import './styles.css'
import TranslateProperty from "../../../components/TranslateProperty";
import Input from "../Input";

const SearchInput = forwardRef(({
                              min,
                              max,
                              maxLength,
                              minLength,
                              name,
                              value,
                              onChange,
                              placeholder = 'search',
                              style = {},
                              containerStyle = {},
                              className = '',
                              disabled = false,
                              isTextarea,
                              resize,
                              onBlur = () => {},
                              defaultValue,
                              variant = 'default', //  flat
                          }, ref) => {

    return (
            <div className="search-input-container" style={containerStyle}>
                <TranslateProperty properties={[{ key: 'placeholder', value: placeholder }]}>
                    <Input
                        ref={ref}
                        defaultValue={defaultValue}
                        min={min}
                        max={max}
                        maxLength={maxLength}
                        minLength={minLength}
                        name={name}
                        value={value}
                        onChange={onChange}
                        placeholder={placeholder}
                        style={{
                            ...style
                        }}
                        className={className}
                        onBlur={(e) => {
                            if (typeof onBlur === 'function') {
                                onBlur(e);
                            }
                        }}
                        disabled={disabled}
                        variant={variant}
                        leadingIcon={(
                            <SearchIcon
                                width={18}
                                height={18}
                                className="search-input-icon"
                                stroke="currentColor"
                            />
                        )}
                    />
                </TranslateProperty>
            </div>
        )
});

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components-new/form/SearchInput/index.jsx